import { i18n } from '@/plugins/i18n';
import formatHelper from '@nextories/vue-core-components/src/utils/helpers/format';

export default {
	...formatHelper,
	formatDateWithTimezone(date: string) {
		const d = new Date(date);
		const year = d.getFullYear();
		const month = this.formatNumberDate(d.getMonth() + 1);
		const days = this.formatNumberDate(d.getDate());
		const hours = this.formatNumberDate(d.getHours());
		const offsetMinutes = -d.getTimezoneOffset();
		const sign = offsetMinutes >= 0 ? '+' : '-';
		const absoluteOffsetMinutes = Math.abs(offsetMinutes);
		const offsetHours = this.formatNumberDate(Math.floor(absoluteOffsetMinutes / 60));
		const offsetRemainingMinutes = this.formatNumberDate(absoluteOffsetMinutes % 60);
		const tzoffset = `${sign}${offsetHours}:${offsetRemainingMinutes}`;
		return `${year}-${month}-${days}T${hours}:00:00${tzoffset}`;
	},

	formatDateGoogle(date: string) {
		const d = new Date(date);
		const year = d.getUTCFullYear();
		const month = this.formatNumberDate(d.getUTCMonth() + 1);
		const days = this.formatNumberDate(d.getUTCDate());
		const hours = this.formatNumberDate(d.getUTCHours());
		const minutes = this.formatNumberDate(d.getUTCMinutes());
		const seconds = this.formatNumberDate(d.getUTCSeconds());
		return `${year}${month}${days}T${hours}${minutes}${seconds}Z`;
	},

	formatSQLDate(date: string) {
		const d = new Date(date);
		const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
		const month = d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
		const year = d.getFullYear();
		return `${year}-${month}-${day}`;
	},
	
	formatAmount(amount: number): string {
		return i18n.global.n(amount / 100 || 0, 'currency');
	},
};
